import { createContext, useContext, useState, useEffect } from "react";

import { AuthModel } from "@/models/auth/AuthModel";

export const AuthStoreContext = createContext<AuthModel | undefined>(undefined);

export function useAuth(): AuthModel {
  const context = useContext(AuthStoreContext);
  if (context === undefined) {
    throw new Error("useStore must be used within AuthStoreProvider");
  }

  return context;
}

export function AuthStoreProvider({
  serverLoggedIn,
  children,
}: {
  serverLoggedIn: boolean;
  children: React.ReactNode;
}) {
  const [authStore] = useState(() => new AuthModel({ serverLoggedIn }));
  useEffect(() => authStore.subscribeToAuthChanges(), [authStore]);

  return <AuthStoreContext.Provider value={authStore}>{children}</AuthStoreContext.Provider>;
}
